<template>
  <div>
    <!-- empty Data component -->
    <empty-data v-if="emptyDataFlag" v-bind:text="emptyDataText"></empty-data>

    <!-- 급여구분 카드 -->
    <v-row v-else class="ma-0 pay-tile-list">
      <v-col cols="12" class="tile-outer">
        <v-row class="ma-0 pa-0">
          <!-- 반복문 -->
          <v-col
            cols="4"
            v-for="(item, i) in searchList"
            :key="i"
            class="text-center tile-inner"
          >
            <v-card
              elevation="0"
              color="lightBlueGrey"
              class="tile-item"
              @click="selectPayCard(item)"
            >
              <icon-pay v-if="item.payCd == 'A1'" :width="24" :height="24" />
              <icon-pay-bonus v-else :width="24" :height="24" />
              <div v-text="item.title" class="box-title"></div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* 급여구분 카드 컴포넌트 */
import EmptyData from '@/components/common/EmptyData.vue';
import IconPay from '@/assets/customIcon/IconPay.vue';
import IconPayBonus from '@/assets/customIcon/IconPayBonus.vue';
import { getPayList } from '@/api/payStatus.js';
import messageConstants from '@/const/messageConstants.js';
import dayjs from 'dayjs';

export default {
  props: {
    propsYear: {
      type: String,
    },
  },
  data: () => ({
    emptyDataFlag: false, // 조회결과없음 플래그
    searchList: [],
    emptyDataText: messageConstants.emptyDataMsg_1,
  }),
  watch: {
    propsYear() {
      this.fetchCalcDayList();
    },
  },
  methods: {
    /* 급여명세서 카드선택 */
    selectPayCard(item) {
      const paramObj = {
        payActionCd: item.payActionCd,
        payActionNm: item.payActionNm,
        paymentMonth: item.paymentMonth, // 지급월
        paymentMon: item.paymentMon, // 지급총액
      };
      // 급여명세서상세 모달 호출
      this.$emit('openModal', paramObj);
    },
    /* 급여내역 목록조회(카드조회) */
    async fetchCalcDayList() {
      try {
        const response = await getPayList({
          searchPaySYm: this.propsYear + '01',
          searchPayEYm: this.propsYear + '12',
        });
        const dataList = response.data.data;

        let payCardList = [];
        dataList.forEach(data => {
          //const paymentMonth = dayjs(data.paymentYmd).format('M');
          const paymentMonth = dayjs(data.payYm).format('M');
          const paymentNm = data.payActionNm.trim().substr(11);

          payCardList.push({
            ...data,
            title: `${paymentMonth}월 ${paymentNm}`,
            paymentMonth,
          });
        });

        this.searchList = payCardList;

        // 조회결과없음 플래그값 세팅
        this.emptyDataFlag = this.searchList.length < 1;

        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      } catch (error) {
        console.log(error);
        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      }
    },
  },
  created() {
    this.fetchCalcDayList();
  },
  components: {
    EmptyData,
    IconPay,
    IconPayBonus,
  },
};
</script>

<style></style>
